<template>
  <div class="padding-left">
    <fieldset role="tabpanel" aria-labelledby="component-h-0" class="body current" aria-hidden="false">
      <h2>{{ $t('companyBase.completeShopInfo') }}</h2>
      <el-row>
        <el-col :span="12">
          <el-form label-width="120px">
            <el-form-item :label="$t('companyBase.companyName')" required>
              <el-input 
                v-model="companyBaseInfo.name" 
                :placeholder="$t('companyBase.companyNamePlaceholder')"
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('companyBase.shopType')" required>
              <el-select 
                v-model="companyBaseInfo.shopType" 
                style="width:100%"
                :placeholder="$t('companyBase.shopTypePlaceholder')"
              >
                <el-option 
                  v-for="item in companyBaseInfo.shopTypes"
                  :key="item.shopTypeId"
                  :label="item.typeName"
                  :value="item.shopTypeId"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('companyBase.shopName')" required>
              <el-input 
                v-model="companyBaseInfo.shopName" 
                :placeholder="$t('companyBase.shopNamePlaceholder')"
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('companyBase.shopArea')" required>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-select 
                    v-model="selectProv" 
                    @change="getProv(selectProv)"
                    :placeholder="$t('companyBase.provincePlaceholder')"
                    style="width:100%"
                  >
                    <el-option 
                      v-for="item in provs"
                      :key="item.areaCode"
                      :label="item.areaName"
                      :value="item.areaCode"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select 
                    v-model="selectCity" 
                    @change="getCity(selectCity)"
                    :placeholder="$t('companyBase.cityPlaceholder')"
                    v-if="selectProv!=''"
                    style="width:100%"
                  >
                    <el-option 
                      v-for="item in citys"
                      :key="item.areaCode"
                      :label="item.areaName"
                      :value="item.areaCode"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select 
                    v-model="selectArea" 
                    @change="getArea(selectArea)"
                    :placeholder="$t('companyBase.areaPlaceholder')"
                    v-if="selectCity!=''"
                    style="width:100%"
                  >
                    <el-option 
                      v-for="item in areas"
                      :key="item.areaCode"
                      :label="item.areaName"
                      :value="item.areaCode"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item :label="$t('companyBase.shopAddress')" required>
              <el-input 
                v-model="companyBaseInfo.address" 
                :placeholder="$t('companyBase.shopAddressPlaceholder')"
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('companyBase.contactPhone')" required>
              <el-input 
                v-model="companyBaseInfo.tel" 
                :placeholder="$t('companyBase.contactPhonePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="10" :offset="2">
          <div class="text-center">
            <div style="margin-top: 20px;">
              <i class="el-icon-office-building" style="font-size: 240px; color: #e5e5e5;"></i>
            </div>
          </div>
        </el-col>
      </el-row>
    </fieldset>
  </div>
</template>

<script>
import { getAreas, listShopTypes } from '@/api/common/companyApi'

export default {
  name: 'CompanyBase',
  data() {
    return {
      companyBaseInfo: {
        name: "",
        shopName: '',
        areaAddress: '',
        address: "",
        tel: "",
        storeTypeCd: "800900000005",
        nearbyLandmarks: "无",
        areaCode: '',
        shopType: '',
        shopTypes: [],
      },
      areas: [],
      provs: [],
      citys: [],
      selectProv: '',
      selectCity: '',
      selectArea: '',
      allCity: []
    }
  },
  created() {
    this._initArea('101', '0')
    this._listShopTypes()
    console.log(this.allCity)
  },
  watch: {
    companyBaseInfo: {
      deep: true,
      handler() {
        this.$emit('company', 'notifyCompanyInfo', this.companyBaseInfo)
      }
    }
  },
  methods: {
    getProv(_prov) {
      this._initArea('202', _prov)
    },
    getCity(_city) {
      this._initArea('303', _city)
    },
    getArea(_area) {
      this.companyBaseInfo.areaAddress = ''
      if (!this.provs) return

      this.provs.forEach(_param => {
        if (_param.areaCode == this.selectProv) {
          this.companyBaseInfo.areaAddress = _param.areaName
        }
      })

      this.citys.forEach(_param => {
        if (_param.areaCode == this.selectCity) {
          this.companyBaseInfo.areaAddress += _param.areaName
        }
      })

      this.areas.forEach(_param => {
        if (_param.areaCode == this.selectArea) {
          this.companyBaseInfo.areaAddress += _param.areaName
        }
      })

      this.companyBaseInfo.areaCode = _area
    },
    async _initArea(areaLevel, parentAreaCode) {
      try {
        const res = await getAreas({ areaLevel, parentAreaCode })
        const areas = res.data || []
        
        if (areaLevel === '101') {
          this.provs = areas
        } else if (areaLevel === '202') {
          this.citys = areas
        } else {
          this.areas = areas
        }
      } catch (error) {
        console.error('获取地区失败:', error)
        this.$message.error(this.$t('common.getAreaFailed'))
      }
    },
    async _listShopTypes() {
      try {
        const res = await listShopTypes({ page: 1, row: 100 })
        this.companyBaseInfo.shopTypes = res.data || []
      } catch (error) {
        console.error('获取店铺类型失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.padding-left {
  padding-left: 20px;
}
</style>